/**
 * Flutter 통신 테스트를 위한 헬퍼 함수들
 */

import { flutterBridge } from './flutterBridge';
import { devLog, devWarn, devError } from '../utils/devLogger';

export class FlutterTestHelper {
  /**
   * 페이지 로드 시 Flutter로 테스트 메시지 전송
   */
  static sendTestMessage() {
    devLog('🧪 Flutter 테스트 메시지 전송 시작');
    
    const testMessage = {
      type: 'TEST_MESSAGE',
      data: {
        message: 'React에서 Flutter로 테스트 메시지입니다',
        timestamp: Date.now(),
        pageUrl: window.location.href,
        userAgent: navigator.userAgent
      }
    };
    
    // 3초 후에 테스트 메시지 전송 (페이지 로딩 완료 후)
    setTimeout(() => {
      devLog('🧪 테스트 메시지 전송:', testMessage);
      flutterBridge.sendMessage(testMessage);
    }, 3000);
    
    // 5초 후에 추가 테스트 메시지 전송
    setTimeout(() => {
      const additionalTest = {
        type: 'HEARTBEAT',
        data: {
          message: 'React 앱이 정상 동작 중입니다',
          timestamp: Date.now()
        }
      };
      devLog('💓 하트비트 메시지 전송:', additionalTest);
      flutterBridge.sendMessage(additionalTest);
    }, 5000);
  }

  /**
   * 로컬스토리지의 Flutter 관련 데이터 확인
   */
  static checkFlutterData() {
    devLog('📋 Flutter 관련 localStorage 데이터:');
    devLog('- 마지막 메시지:', localStorage.getItem('flutter_last_message'));
    devLog('- 마지막 에러:', localStorage.getItem('flutter_last_error'));
    devLog('- 로그인 전송 기록:', localStorage.getItem('flutter_login_sent'));
    devLog('- 토큰 데이터:', localStorage.getItem('flutter_token_data'));
  }

  /**
   * Flutter 통신 디버그 정보 출력
   */
  static debugFlutterCommunication() {
    devLog('🔍 Flutter 통신 디버그 정보:');
    devLog('- User Agent:', navigator.userAgent);
    devLog('- window.FlutterBridge:', (window as any).FlutterBridge);
    devLog('- window.flutter:', (window as any).flutter);
    devLog('- window.parent !== window:', window.parent !== window);
    devLog('- 현재 URL:', window.location.href);
    
    this.checkFlutterData();
  }
}

// 페이지 로드 시 자동으로 테스트 메시지 전송
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    FlutterTestHelper.sendTestMessage();
    FlutterTestHelper.debugFlutterCommunication();
  });
}
